import * as React from 'react';
import { connect } from 'react-redux';
import { mapDispatchToProps } from '../../redux/actions';
import { completeLogin, login } from '../../security/IdentityService';
import '../../css/Login.scss';
import { saveUserIdentity } from '../../api-calls/projectDataService';

// expected props
interface IProps {
  updateRedux: any;
  history: any;
}
// local state
interface IState {
  success: boolean;
}

class IdentityLogin extends React.Component<IProps, IState> {
  public state: IState = {
    success: true
  };

  //This page is only ever reached as the OIDC redirect_uri, right after IdentityServer redirects
  //back with a fresh id_token/access_token in the URL fragment - so always process the callback.
  async componentDidMount() {
    this.props.updateRedux('UPDATE_DISPLAY', { showLoader: true });
    const user = await completeLogin();

    if (user != null) {
      this.saveUserIdentity(user);
      this.props.updateRedux('UPDATE_DISPLAY', { showLoader: false });
      this.props.history.push('/project');
    } else {
      this.setState({ success: false });
      this.props.updateRedux('UPDATE_DISPLAY', { showLoader: false });
    }
  }
  saveUserIdentity(user: any){
    const userIdentityRequest = {
      LoginId: user.profile.sub,
      FirstName: user.profile.FirstName,
      LastName: user.profile.LastName,
      Email: user.profile.Email,
      ProfileData: user.profile.profiledata
    };

    saveUserIdentity(userIdentityRequest);
  }
  public render() {
    return (
      <div className="login-inputs">
        {this.state.success === false ? (
          <div>
            <div>Login unsuccessful</div>
            <br />
            <br />
            <button onClick={() => login()}>Try again</button>
          </div>
        ) : null}
      </div>
    );
  }
}

//------------------ Redux ----------------------------
function mapStateToProps(state: any) {
  return {};
}
export default connect(mapStateToProps, mapDispatchToProps)(IdentityLogin);
